import type { InputCheckboxFieldProps } from '@presentation/components';
import { ErrorText } from '@presentation/components';
import { hasFieldError } from '@presentation/utils';
import { useField } from 'formik';
import type { FC } from 'react';
import * as Styled from './styled';

export * from './types';

export const InputCheckboxField: FC<InputCheckboxFieldProps> = (props) => {
  const { name, disabled = false, children, id, ...rest } = props;
  const [field, meta, helpers] = useField<boolean>(name);

  const prefix = id ?? `checkbox-${name}`;

  return (
    <>
      <Styled.Input
        {...rest}
        checked={field.value}
        disabled={disabled}
        type="checkbox"
        id={prefix}
        onChange={(event) => {
          helpers.setValue(event.target.checked);
        }}
        onBlur={field.onBlur}
      />
      <Styled.Label disabled={disabled} htmlFor={prefix}>
        {children}
      </Styled.Label>
      {hasFieldError(meta) && <ErrorText>{meta.error}</ErrorText>}
    </>
  );
};
